import React from "react";
import ContactSection from "../YouTubeThumbnailHome/ContactSection";

const Contact = () => {
  return (
    <>
      <ContactSection />
    </>
  );
};

export default Contact;
